var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('proposal-form',{attrs:{"schema":_vm.proposalSchema,"isBoxed":false}}),_c('offer-form',{attrs:{"schema":_vm.schema,"isBoxed":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }